import React from 'react'
import _ from 'lodash'

const FILTER_ARRAY = {
    'Arts and Culture': ['aquarium', 'art_gallery', 'library', 'museum', 'university'],
    'Entertainment': ['amusement_park', 'casino', 'movie_theater', 'night_club', 'stadium', 'zoo'],
    'Food and Drink': ['bakery', 'cafe', 'night_club', 'restaurant', 'food'],
    'Shopping': ['book_store', 'clothing_store', 'department_store', 'florist', 'jewelry_store', 'store'],
    'Relaxation': ['spa'],
    'Resources': ['airport', 'bus_station', 'embassy', 'atm', 'hospital'],
    'Sightseeing': ['amusement_park', 'aquarium', 'library', 'park', 'stadium', 'zoo', 'church', 'cemetery', 'point_of_interest']
}

const QUERY_ARRAY = {
    'Arts and Culture': ['art_gallery', 'museum'],
    'Entertainment': ['night_club', 'zoo'],
    'Food and Drink': ['cafe', 'restaurant'],
    'Sightseeing': ['park', 'church', ],
    'Shopping': ['clothing_store', 'jewelry_store'],
    'Relaxation': ['spa'],
    'Resources': ['airport', 'embassy']
}

export default {
    getFilters: function () {
        return FILTER_ARRAY
    },

    getQueryMappings: function () {
        return QUERY_ARRAY
    },

    getIcon: function(item) {
        if (item.get('type') === 'accommodation' || item.get('accommodation_id')) {
            // Accom has type set
            return <i className="icon-accom"/>
        } else if (item.get('type') === 'attraction' || item.get('place_id')) {
            // activities should always have a place id
            let cat = this.activityContains(item)
            switch (cat) {
                case 'Arts and Culture':
                    return <i className="icon-musuem"/>
                case 'Entertainment':
                    return <i className="icon-film"/>
                case 'Food and Drink':
                    return <i className="icon-food"/>
                case 'Sightseeing':
                    return <i className="icon-binoculars"/>
                case 'Shopping':
                    return <i className="icon-shopping"/>
                case 'Relaxation':
                    return <i className="icon-spa"/>
                case 'Resources':
                    return <i className="icon-book"/>
                default:
                    return <i className="icon-location_a"/>
            }
        } else if (item.get('type') === 'destination') {
            return <i className="icon-location_a"/>
        } else {
            // assuming travel for right now....
            // return <i className="icon-plane"></i>
            // TODO: Destinations coming through promoted region dont have a "type" so they show up as planes...
            return <i className="icon-location_a"/>
        }
    },

    getIconAndLabel: function(item) {
        return <div className="category-with-label">{this.getIcon(item)}<span>{this.activityContains(item)}</span></div>
    },

    activityContains: function(item) {
        if (item.get('types') || item.get('keywords')) {
            let keywords = item.get('types') || item.get('keywords')
            let category = _.findKey(FILTER_ARRAY, function(values) {
                let isFound = false
                _.each(values, function(myVal) {
                    if (keywords.indexOf(myVal) >= 0) isFound = true
                })
                return isFound
            })
            return category
        } else {
            return false
        }
    }
}
